exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-body {\n\tfont-size: 16px;\n}\n\n.dropdown-menu {\n\tz-index:9999;\n}\n", ""]);

// exports
